<template>
    <div>
        <h2>Kategorie wählen</h2>
        <p>Wählen Sie die Kategorie, in der Ihr Inserat erscheinen soll.</p>
        <div class="row">
            <div class="col-md-4">
                <ul class="list-group" v-if="categories_1">
                    <li class="list-group-item"
                        v-for="category in categories_1"
                        :key="category.id"
                        @click="getCategories_2(category.id)"
                        :class="{'selected': selected_category_1 == category.id}">
                        {{category.name}}
                    </li>
                </ul>
            </div>
            <div class="col-md-4 mt-md-0 mt-3">
                <ul class="list-group" v-if="categories_2">
                    <li class="list-group-item"
                        v-for="category in categories_2"
                        :key="category.id"
                        @click="getCategories_3(category.id, true)"
                        :class="{'selected': selected_category_2 == category.id}">
                        {{category.name}}
                    </li>
                </ul>
            </div>
            <div class="col-md-4 mt-md-0 mt-3">
                <ul class="list-group" v-if="categories_3">
                    <li class="list-group-item"
                        v-for="category in categories_3"
                        :key="category.id"
                        @click="selectCategory(category.id)"
                        :class="{'selected': selected_category_3 == category.id}">
                        {{category.name}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt-3">
            <p>Suchen Sie nach einer Kategorie in der Ihr Inserat erscheinen soll.</p>
            <div style="position:relative" v-bind:class="{'open':true}">
              <input type="text" class="form-control" v-model="search_category" @input="getCatSuggestions">
              <div v-if="found_categories && found_categories.length > 0">
                 <div v-if="open" class="dropdown-menu show" style="width:100%" >
                    <li class="dropdown-item"
                        v-for="(found_category,index) in found_categories"
                        :key="found_category.id"
                        @click="suggestionClick(index)"
                        @enter="suggestionClick(index)"
                    >
                        <label>{{ found_category.label }}</label>
                    </li>
                 </div>
              </div>
            </div>
        </div>
        <div class="mt-3 text-right">
            <button v-if="create" class="btn btn-success" @click="weiter()">Weiter</button>
            <button v-if="!create" class="btn btn-success" @click="save()">Speichern</button>
        </div>
        <b-modal ref="error-modal" :title="'Fehlermeldung'">
            <div class="d-block">
                <h5>{{$t('intern_object_erstellen.category_error')}}</h5>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="danger" @click="cancel()">Schließen</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Inserat from '../../../classes/Inserat.js';

    export default {
      data() {
            return {
                selected_category: 0,
                categories_1: [],
                categories_2: [],
                categories_3: [],
                selected_category_1: 0,
                selected_category_2: 0,
                selected_category_3: 0,
                search_category: '',
                found_categories: [],
                catSelected : '',
                openSearchCatList : false
            }
        },
        props:['create'],
        computed:{
          open(){
            return this.openSearchCatList;
          }
        },
        mounted() {
            this.scrollTop();
            this.getCategories_1();

            if(localStorage.getItem('currentSelectedCategory') !== null){
                let arrayOfCategories = JSON.parse(localStorage.getItem('currentSelectedCategory'));

                this.selected_category_3 = arrayOfCategories.selected_category_3;
                this.getCategories_2(arrayOfCategories.selected_category_1);
                this.getCategories_3(arrayOfCategories.selected_category_2);
                this.selected_category = arrayOfCategories.selected_category_3;

            }else if(this.$route.params.id > 0){
                let category_id = this.$store.state.editObject.category_id;

                this.$http.get('categoryApi/getAncestors?categoryId=' + category_id).then(response => {
                    let categories = JSON.parse(response.data);
                    let secondCategory = categories[2] ? categories[2].id : category_id;

                    this.getCategories_2(categories[1].id);
                    this.getCategories_3(secondCategory);
                    this.selected_category = category_id;

                    if(secondCategory != category_id){
                        this.selected_category_3 = category_id;
                    }

                }).catch(error => {
                    console.log(error);
                })
            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            getCatSuggestions(){
              if(this.search_category.length > 2){
                  this.$http.get('/categoryApi/CatSuggestion', {
                        params: {
                            cat: this.search_category,
                            inserieren: true
                        }
                    }).then((response) => {
                        this.found_categories = JSON.parse(response.data);
                        this.found_categories = this.found_categories.map(item =>{
                            var anc = '';
                            item.ancestors.forEach(item => {
                              anc+= item + ' > ';
                            });
                            return {
                              label: anc + item.name,
                              value: anc + item.name,
                              id: item.id
                            };
                        });
                        if (this.openSearchCatList == false) {
                            this.openSearchCatList = true;
                        }

                    }).catch(err => {console.log(err)});
              }
              else{
                this.openSearchCatList == false;
              }
            },
            suggestionClick(index) {
                this.openSearchCatList = false;
                this.search_category = this.found_categories[index].value;

                this.$http.get('categoryApi/getAncestors?categoryId=' + this.found_categories[index].id).then(response => {
                    let categories = JSON.parse(response.data);
                    let secondCategory = categories[2] ? categories[2].id : this.found_categories[index].id;

                    this.getCategories_2(categories[1].id);
                    this.getCategories_3(secondCategory);
                    this.selected_category = this.found_categories[index].id;

                    if(secondCategory != this.found_categories[index].id){
                        this.selected_category_3 = this.found_categories[index].id;
                    }

                }).catch(error => {
                    console.log(error);
                })

            },
            isActive(index) {
                return index === this.current;
            },
            getCategories_1(){
                this.categories_2 = [];
                this.categories_3 = [];
                this.$http.get('/categoryApi/directChildren', {
                    params: {
                        categoryId: 0
                    }
                }).then((response) => {
                    this.categories_1 = JSON.parse(response.data);
                }).catch(err => {console.log(err)});
            },
            getCategories_2(id){
                this.categories_3 = [];
                this.selected_category = 0;
                this.selected_category_1 = id;
                this.$http.get('/categoryApi/directChildren', {
                    params: {
                        categoryId: id
                    }
                }).then((response) => {
                    this.categories_2 = JSON.parse(response.data);
                }).catch(err => {console.log(err)});
            },
            getCategories_3(id, remove_selected_3 = false){
                this.selected_category = 0;
                this.selected_category_2 = id;
                this.$http.get('/categoryApi/directChildren', {
                    params: {
                        categoryId: id
                    }
                }).then((response) => {
                    if(JSON.parse(response.data).length == 0){
                        this.categories_3 = [];
                        this.selected_category = id;
                    }else{
                        this.categories_3 = JSON.parse(response.data);
                    }
                }).catch(err => {console.log(err)});

                if(remove_selected_3){
                    this.selected_category_3 = 0;
                }
            },
            selectCategory(id){
                this.selected_category = id;
                this.selected_category_3 = id;
            },
            weiter(){
                if(this.selected_category != 0){
                    let inserat = new Inserat();
                    inserat.setCategoryId(this.selected_category);
                    localStorage.setItem('currentObject', JSON.stringify(inserat));
                    localStorage.setItem('currentObjectTab', 'description');
                    localStorage.setItem('currentSelectedCategory', JSON.stringify({
                        selected_category_1: this.selected_category_1,
                        selected_category_2: this.selected_category_2,
                        selected_category_3: this.selected_category_3,
                    }));
                    this.$emit('nextTab','description');
                }else{
                    this.$refs['error-modal'].show();
                }
            },
            save() {
                if(this.selected_category != 0){
                    let object = this.$store.state.editObject;
                    object.category_id = this.selected_category;

                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id, object).then(response => {
                        this.$store.state.editObject = object;
                        this.$store.state.loading = false;
                        this.$emit('nextTab','description');
                        this.$emit('success', response.data);
                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                } else {
                    this.$refs['error-modal'].show();
                }
            }
        },
    }
</script>

<style scoped>
.selected{
    background-color: #5FA963;
    color: white;
    font-weight: 700;
}
.list-group{
    max-height: 442px !important;
    overflow-y: auto;
}
.list-group-item{
    cursor: pointer;
}
.dropdown-item:hover{
  background-color: #5FA963;
}
</style>
